import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ArrowRight } from 'lucide-react';

import { useCreateInconsistencies } from '@/api/mutations/useCreateInconsistencies';
import useGetCaseOverview from '@/api/queries/useGetCaseOverview';
import { Button } from '@/components/atoms/new-button';

const InconsistencyRunPopup = ({ caseId, closeModal }: { caseId: string; closeModal: () => void }) => {
  const { data: responseCaseOverview, isLoading } = useGetCaseOverview(caseId);
  const { mutateAsync: createInconsistencies, isLoading: isCreatingInconsistencies } = useCreateInconsistencies(caseId);
  const pages = responseCaseOverview?.pages ?? 0;
  const tokens = Math.ceil(pages / 5);

  const handleCreateInconsistencies = async () => {
    await createInconsistencies();
    closeModal();
  };

  return (
    <div>
      <div className="flex h-24 items-center justify-center bg-gray-100"></div>
      <div className="px-8 pb-10">
        <p className="pt-4 pb-2 text-lg font-semibold">Generate Inconsistencies</p>
        <div className="flex flex-col gap-4 text-gray-700">
          {isLoading ? (
            <div className="flex h-full w-full items-center justify-center py-8">
              <FontAwesomeIcon icon={faCircleNotch} className="fa-spin text-gray-400" />
            </div>
          ) : (
            <p>This will use {tokens} pages/credits.</p>
          )}

          <div>
            <Button
              variant="primary"
              size="sm"
              onClick={handleCreateInconsistencies}
              disabled={isCreatingInconsistencies}
            >
              Proceed
              {isCreatingInconsistencies ? (
                <FontAwesomeIcon icon={faCircleNotch} className="fa-spin text-gray-400" />
              ) : (
                <ArrowRight className="h-4 w-4" />
              )}
            </Button>
          </div>

          <p className="border border-x-0 border-b-0 pt-4 text-sm text-gray-500">
            You will receive an email when this is complete.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InconsistencyRunPopup;
